import script from "./MainPage_KOR.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainPage_KOR.vue?vue&type=script&setup=true&lang=ts"

import "./MainPage_KOR.vue?vue&type=style&index=0&id=422e4b6e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-422e4b6e"]])

export default __exports__